// Shared types for reference admin modals
import type { CountryApiRow, CurrencyApiRow, StateProvinceApiRow } from '@/api/reference-admin';

// Union type for all API entity types
export type ApiRowType = CountryApiRow | CurrencyApiRow | StateProvinceApiRow;

/**
 * Plain identifier for one reference row, for accessible names on the icon-only
 * row triggers ("Edit country Canada"). Prose that wants quotes and the code in
 * parentheses builds its own string -- this stays speakable.
 */
export function referenceAdminEntityName(entity: ApiRowType): string {
  return entity.name || entity.code || 'item';
}

export interface FieldConfig {
  key: string;
  label: string;
  type: 'text' | 'number' | 'checkbox' | 'select';
  required?: boolean;
  placeholder?: string;
  maxLength?: number;
  minLength?: number; // Added for text field minimum length validation
  min?: number;
  max?: number;
  options?: { value: string; label: string }[];
  defaultValue?: string | number | boolean;
}

export interface EntityConfig {
  name: string;
  singularName: string;
  fields: FieldConfig[];
  createFn: (data: Record<string, unknown>) => Promise<ApiRowType>;
  updateFn: (id: number, data: Record<string, unknown>) => Promise<ApiRowType>;
  deleteFn: (id: number) => Promise<{ success: boolean; message: string }>;
}
